'use client';
import Input, { InputProps } from '@components/Form/Input';
import { useFormikContext } from 'formik';
import React from 'react';

export const formatPhoneNumber = (newValue: string) => {
  const numbers = newValue.replace(/\D/g, '');
  const group1 = numbers.slice(0, 3);
  const group2 = numbers.slice(3, 6);
  const group3 = numbers.slice(6, 10);
  if (group3) {
    return `(${group1}) ${group2}-${group3}`;
  }
  if (group2) {
    const trailing = newValue.endsWith('-') ? '-' : '';
    return `(${group1}) ${group2}${trailing}`;
  }
  if (group1) {
    if (newValue.endsWith(') ')) {
      return `(${group1}) `;
    }
    if (newValue.endsWith(')')) {
      return `(${group1})`;
    }
    return `(${group1}`;
  }

  return newValue === '(' ? newValue : '';
};

const PhoneInput = ({ onChange, ...rest }: InputProps) => {
  const { setFieldValue } = useFormikContext();
  const handleChange = React.useCallback(
    (e: any) => {
      onChange?.(e);
      setFieldValue(rest.name, formatPhoneNumber(e.target.value));
    },
    [onChange, rest.name, setFieldValue],
  );

  return <Input {...rest} onChange={handleChange} />;
};

export default PhoneInput;
